import { ColumnFiltersState } from "@cayo/shared/components/GridContainer/types/columnFilters";

export const normalizeColumnFilters = (columnFilters: ColumnFiltersState): ColumnFiltersState => {
  return Object.entries(columnFilters).reduce<ColumnFiltersState>((acc, [fieldName, value]) => {
    const normalizedValue = value.trim();

    if (!normalizedValue) {
      return acc;
    }

    return {
      ...acc,
      [fieldName]: normalizedValue.toLocaleLowerCase(),
    };
  }, {});
};
